import { DefaultProjectorFn, MemoizedSelector, createSelector } from '@ngrx/store';
import { AppState } from '../../app.state';

import { BackendStorageState } from './backend-storage.state';

export namespace BackendStorageSelectors {
  export const backendStorageState = (state: AppState): BackendStorageState => state.backendStorage;

  export const selectAdvertBannerVisibility: MemoizedSelector<
    AppState,
    boolean,
    DefaultProjectorFn<boolean>
  > = createSelector(
    backendStorageState,
    (state: BackendStorageState) => state.keys[0]?.AdvertCampagneBannerUserVisibility?.data ?? true
  );
}
